<template>
  <div class="screen_wrap">
    <el-carousel
      ref="carousel"
      trigger="click"
      :height="screenHeight + 'px'"
      :interval="10000"
      :indicator-position="advList.length == 0 ? 'none' : ''"
      arrow="never"
      @mousedown="handleMousedown"
      @mousemove="handleMousemove"
      @mouseup="handleMouseup"
    >
      <el-carousel-item>
        <div class="screen_box">
          <video
            ref="myVideo"
            class="myVideo"
            autoplay
            muted
            poster="//stocksf.yxcps.com/cc/media/yxt_web_bg.png?t=1"
            src="//stocksf.yxcps.com/cc/media/yxt_web.mp4?t=1"
            @ended="handleEnded"
          ></video>

          <div class="text_wrap">
            <div class="left_box">
              <div class="item1">益学AI</div>

              <div class="item2">
                【益学堂×DeepSeek】智能选股功能全新上线！依托千亿级金融大模型，实时扫描全市场标的，动态追踪200+因子挖掘潜力赛道。AI机器学习引擎持续优化投资策略，开启智慧投资新体验。
              </div>

              <div class="item3">
                <div class="btn" @click="buttonClick()">
                  <span class="btn_text">点击使用智能选股</span>
                  <el-icon class="btn_icon" :size="22"><Right /></el-icon>
                </div>
              </div>
            </div>

            <div class="right_box">
              <img src="@/assets/index/screen/bg.png" />
            </div>
          </div>
        </div>
      </el-carousel-item>

      <el-carousel-item v-for="(item, index) in advList" :key="index">
        <img
          :src="item.bannerUrl"
          draggable="false"
          :class="{ handImg: item.bannerRelationUrl }"
          @click="advClick(item)"
        />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
  
<script>
export default {
  data() {
    return {
      videoTime: 2.1, // 从第 n 秒 开始播放视频
      advList: [],

      dragging: false,
      initialX: 0,
      initialY: 0,
      currentX: 0,
      currentY: 0,
      threshold: 50, // 触发切换的最小拖拽距离

      isClick: true, // 假设是点击事件
      isHovering: false, // 点击使用智能选股 是否显示 icon
    };
  },
  props: {
    screenHeight: window.innerHeight,
  },
  created() {
    // console.log(this.screenHeight);
  },
  mounted() {
    this.getAdvList(); // 获取 banner list
  },
  methods: {
    // 监听视频播放结束事件
    handleEnded() {
      // 从第2秒开始播放
      this.$refs.myVideo.currentTime = this.videoTime;
      this.$refs.myVideo.play(); // 重新播放
    },

    // 轮播图 鼠标触摸 左/右滑动
    handleMousedown(event) {
      this.dragging = true;
      this.initialX = event.clientX;
      this.initialY = event.clientY;
      this.isClick = true;
    },
    handleMousemove(event) {
      if (!this.dragging) return;

      this.currentX = event.clientX;
      this.currentY = event.clientY;
      const deltaX = this.currentX - this.initialX;
      const deltaY = this.currentY - this.initialY;

      // 判断是否是滑动操作
      if (
        Math.abs(deltaX) > this.threshold ||
        Math.abs(deltaY) > this.threshold
      ) {
        this.isClick = false; // 不是点击事件，是滑动操作
      }

      const carousel = this.$refs.carousel;
      if (deltaX > this.threshold) {
        carousel.prev();
        this.dragging = false;
      } else if (-deltaX > this.threshold) {
        carousel.next();
        this.dragging = false;
      }
    },
    handleMouseup() {
      this.dragging = false;
    },

    // 点击使用智能选股 click
    buttonClick() {
      this.COMMON.routerSkip("strategyList");
    },

    // 获取 banner list
    getAdvList() {
      let data = {
        agencyId: "www.yxcps.com",
        // agencyId: "www.devyxcps.cn",
        bannerJsp: 1,
      };

      this.API.CLOUDGet("cms/api/website/banner/list", data).then((res) => {
        // console.log(res);
        let datas = res.data.data;
        // console.log(datas);

        if (datas) {
          this.advList = datas.map((obj) => {
            if (obj.bannerUrl && !obj.bannerUrl.includes("http")) {
              obj.bannerUrl = `//sf.yxcps.com/${obj.bannerUrl}`;
            }
            return obj;
          });
        }
      });
    },

    // adv click
    advClick(item) {
      let urlPattern = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;

      if (item.bannerRelationUrl && urlPattern.test(item.bannerRelationUrl)) {
        if (this.isClick) {
          this.COMMON.zhuGeMaidian("in_web", {
            web_page_link: item.bannerRelationUrl,
          }); // 诸葛 埋点

          window.open(item.bannerRelationUrl);
        }
      }
    },
  },
};
</script>
  
<style lang="less" scoped>
.screen_wrap {
  .myVideo,
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .screen_box {
    height: 100%;
    position: relative;

    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;

    .text_wrap {
      height: 100%;
      box-sizing: border-box;
      padding: 0 100px;
      position: absolute;
      top: 60px;
      display: flex;
      justify-content: space-around;
      align-items: center;

      .left_box {
        width: 38%;
        padding-left: 1%;
        color: #fff;
        padding-bottom: 200px;

        .item1 {
          font-size: 48px;
          font-weight: bold;
        }

        .item2 {
          margin-top: 24px;
          font-size: 20px;
          font-weight: 400;
          text-align: justify;
        }

        .item3 {
          margin-top: 24px;
          font-size: 12px;
          display: flex;
          width: 164px;
          height: 46px;
          font-weight: 600;
          border: 1px solid #e5e7eb;
          border-radius: 9999px;

          .btn {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            .btn_text {
              transition: transform 0.3s ease;
            }

            .btn_icon {
              width: 0;
              opacity: 0;
              transition: opacity 0.3s ease, transform 0.3s ease;
            }

            &:hover {
              transform: translateX(6px);

              .btn_text {
                transform: translateX(-6px);
              }

              .btn_icon {
                width: 22px;
                opacity: 1;
                transform: translateX(0);
              }
            }
          }
        }
      }

      .right_box {
        width: 40%;
        padding-left: 2%;
        padding-bottom: 8%;
        box-sizing: border-box;

        img {
          width: 100%;
          display: block;
        }
      }
    }
  }

  .handImg {
    cursor: pointer;
  }
}
</style>